import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperNumbers from "../../../helpers/numbers";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function AddTransactionScoreToWalletAdvertiser() {
  const [score, setScore] = useState(30000);
  const [walletAdvertiser, setWalletAdvertiser] = useState(0);
  const history = useHistory();
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  useEffect(() => {
    if (score < 0) {
      return;
    }
    setWalletAdvertiser(
      Math.floor(
        score /
          process.env.REACT_APP_COEFFICIENT_CONVERT_SCORE_TO_WALLET_PUBLISHER
      )
    );
  }, [score]);

  const inputScoreChangeHandler = (e) => {
    let number = e.target.value;
    number = helperNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setScore(parseInt(number));
  };

  const inputScoreBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="درخواست تبدیل امتیاز به شارژ تبلیغ دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/finance/all-transaction-score-to-wallet-advertiser"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}
              <form>
                <div className="form-group">
                  <label>امتیاز</label>
                  <input
                    tabindex="1"
                    type="text"
                    id="price"
                    className="form-control number-finance"
                    value={helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(score)
                    )}
                    onChange={inputScoreChangeHandler}
                    onBeforeInput={inputScoreBeforeInputHandler}
                    dir="ltr"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>شارژ تبلیغ دهنده (تومان)</label>
                  <div className="text-left" style={{ fontSize: "30px" }}>
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(walletAdvertiser)
                    )}
                  </div>
                  <div className="form-group">
                    <ButtonDisable
                      buttonTagHtml={
                        <span className="btn btn-success opacity-50">
                          تبدیل
                        </span>
                      }
                    ></ButtonDisable>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
